const getters = {
    inputHasFocus: state => state.inputHasFocus,
    window: state => state.window
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/Screen/getters.js